import React from "react";
import { GenericValueInput } from "components/Global/Fields";
import { ValueTypes } from "pages/refiAnalysis/supervised/constants";

import { FilterHeader } from "..";

const SingleInputFilter = ({
  title = "",
  valueType = ValueTypes.integer,
  label = "Months",
  value = 0,
  defaultValue = 0,
  setAmount = () => { },
  error = false,
  setError = () => { },
  errorMessage = "",
  onBlur,
  setIsActive = () => {}
}) => {
  const resetAmounts = () => {
    setAmount(defaultValue);
    setError(false);
    setIsActive(false);
  };

  return (
    <div className="filter-panel-filters-wrapper">
      <FilterHeader title={title} resetLabel="Reset" onReset={() => resetAmounts()} />
      <div className="filter-panel-filters-content-wrapper">
        <div>
          <GenericValueInput
            isMin={false}
            valueType={valueType}
            label={label}
            name={`dsFilter${label.trim()}`}
            value={value}
            minMaxError={false}
            defaultValue={defaultValue}
            setAmount={setAmount}
            error={error}
            setError={setError}
            onBlur={onBlur}
            errorMessage={errorMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default SingleInputFilter;
